import { call } from '@advanza/api'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import 'global.css'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import '../../shared/css/reset.css'
import Root from './containers/Root'
import './i18n'

// Stale production service workers on l.* hosts can cache broken assets and show a blank page.
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
    const { hostname } = window.location
    if (hostname.startsWith('l.') || hostname.endsWith('.trustoo.nl')) {
        void navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => {
                void registration.unregister()
            })
        })
    }
}

const root = createRoot(document.getElementById('root')!)

const renderApp = () =>
    root.render(
        <HelmetProvider>
            <TooltipPrimitive.Provider delayDuration={200}>
                <BrowserRouter>
                    <Root />
                </BrowserRouter>
            </TooltipPrimitive.Provider>
        </HelmetProvider>,
    )

if (window._user && window._user.id) {
    renderApp()
} else {
    call('apps/get-app-vars/office')
        .then((json) => {
            window._user = json.user
            window._appConfig = json.config
            renderApp()
        })
        .catch((error) => {
            console.error('Failed to bootstrap office app:', error)
            renderApp()
        })
}
